/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Zone {
    ONE = 'one',
    TWO = 'two'
}


export function instanceOfZone(value: any): boolean {
    for (const key in Zone) {
        if (Object.prototype.hasOwnProperty.call(Zone, key)) {
            if (Zone[key as keyof typeof Zone] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ZoneFromJSON(json: any): Zone {
    return ZoneFromJSONTyped(json, false);
}

export function ZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Zone {
    return json as Zone;
}

export function ZoneToJSON(value?: Zone | null): any {
    return value as any;
}

export function ZoneToJSONTyped(value: any, ignoreDiscriminator: boolean): Zone {
    return value as Zone;
}

